module.exports = __webpack_public_path__ + "static/img/ftgeolocation.65cec0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftgeolocation.png
// module id = IWUc
// module chunks = 0